import React from "react";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import { Box, Button, Collapse, Grid, IconButton, Paper, TextField } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { FormikInitialValues, FormikValidationSchema } from "./_titulo_utils";

/**
 * Formulario para agregar nuevos títulos.
 * @param {*} is_open TRUE: Formulario mostrado | FALSE: Formulario oculto.
 * @param {*} formik Datos del formulario.
 * @param {*} set_is_open Método encargado de cambiar el State IsOpen.
 * @returns Component.
 */
export default function TituloDialog(props) {
	const { is_open, formik, set_is_open } = props;
	const notistack = useSnackbar();

	const formikDialog = useFormik({
		initialValues: FormikInitialValues,
		validationSchema: FormikValidationSchema,
		onSubmit: async function (values, helper) {
			try {
				notistack.enqueueSnackbar("Agregando nuevo título...", {
					anchorOrigin: {
						horizontal: "center",
						vertical: "bottom"
					},
				});

				//Se actualizan los datos del cargo.
				formik.setFieldValue("titulos", [...formik.values.titulos, values]);

				notistack.enqueueSnackbar("Título agregado exitosamente.", {
					variant: "success",
					anchorOrigin: {
						horizontal: "center",
						vertical: "bottom"
					},
					action: (key) => <IconButton onClick={() => notistack.closeSnackbar()}><Close /></IconButton>
				});
			} catch (error) {
				console.error(error);
				notistack.enqueueSnackbar("Error al intentar agregar el título.", {
					variant: "error",
					anchorOrigin: {
						horizontal: "center",
						vertical: "bottom"
					},
					action: (key) => <IconButton onClick={() => notistack.closeSnackbar()}><Close /></IconButton>
				});
			} finally {
				handleCloseDialog();
				helper.resetForm();
			}
		}
	});

	/**
	 * Método encargado de cerrar el popup.
	 */
	const handleCloseDialog = () => {
		set_is_open(false);
		formikDialog.resetForm();
	}

	/**
	 * Método encargado de determinar si el botón está habilitado o deshabilitado.
	 * @returns Estado del botón.
	 */
	const isDisabled = () => {
		let check = Boolean(
			formikDialog.isSubmitting ||
			!formikDialog.values.nombre ||
			!formikDialog.values.exp_general ||
			!formikDialog.values.exp_especifica ||
			Object.keys(formikDialog.errors).length > 0
		);
		return check;
	}

	return (
		<Collapse in={is_open}>
			<Paper style={{ padding: 15, borderRadius: 25 }}>
				<Grid container spacing={2}>
					{/* NOMBRE DEL TÍTULO */}
					<Grid item xs={12}>
						<TextField
							name="nombre"
							label="Título"
							value={formikDialog.values.nombre}
							onChange={formikDialog.handleChange}
							variant="outlined"
							fullWidth
							size="small"
							helperText={formikDialog.errors.nombre}
							error={Boolean(formikDialog.errors.nombre)}
						/>
					</Grid>

					{/* EXPERIENCIA GENERAL */}
					<Grid item xs={6}>
						<TextField
							name="exp_general"
							label="Experiencia General"
							value={formikDialog.values.exp_general}
							onChange={formikDialog.handleChange}
							variant="outlined"
							type="number"
							inputProps={{ min: 0, max: 99 }}
							fullWidth
							size="small"
							helperText={formikDialog.errors.exp_general}
							error={Boolean(formikDialog.errors.exp_general)}
						/>
					</Grid>

					{/* EXPERIENCIA ESPECÍFICA */}
					<Grid item xs={6}>
						<TextField
							name="exp_especifica"
							label="Experiencia Específica"
							value={formikDialog.values.exp_especifica}
							onChange={formikDialog.handleChange}
							variant="outlined"
							type="number"
							inputProps={{ min: 0, max: 99 }}
							fullWidth
							size="small"
							helperText={formikDialog.errors.exp_especifica}
							error={Boolean(formikDialog.errors.exp_especifica)}
						/>
					</Grid>

					{/* BOTONES AGREGAR/CANCELAR */}
					<Grid item xs={12}>
						<Box display="flex" justifyContent="flex-end">
							<Box pr={1}>
								<Button variant="contained" onClick={formikDialog.submitForm} disabled={isDisabled()} color="primary">
									Agregar Título
								</Button>
							</Box>
							<Box pl={1}>
								<Button variant="contained" onClick={handleCloseDialog} disabled={formikDialog.isSubmitting} color="secondary">
									Cerrar
								</Button>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Paper>
		</Collapse>
	);
}